<parkour-info-card [style]="'bg-n-200'" icon="broken-link" class="block my-4">
  <p class="font-medium mb-1" data-testId="content-unavailable">
    {{ title }}
  </p>

  <p>{{ description }}</p>
</parkour-info-card>
